import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const AnimatedTyping = ({
  text,
  speed = 100,
  deleteSpeed = 50,
  delay = 1000,
  loop = false,
  className = "",
  showCursor = true,
}) => {
  const [displayedText, setDisplayedText] = useState("");
  const [isTyping, setIsTyping] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    let timeout;

    if (isTyping) {
      if (currentIndex < text.length) {
        timeout = setTimeout(() => {
          setDisplayedText(text.slice(0, currentIndex + 1));
          setCurrentIndex(currentIndex + 1);
        }, speed);
      } else if (loop) {
        timeout = setTimeout(() => {
          setIsTyping(false);
        }, delay);
      }
    } else if (loop) {
      if (currentIndex > 0) {
        timeout = setTimeout(() => {
          setDisplayedText(text.slice(0, currentIndex - 1));
          setCurrentIndex(currentIndex - 1);
        }, deleteSpeed);
      } else {
        timeout = setTimeout(() => {
          setIsTyping(true);
        }, delay);
      }
    }

    return () => clearTimeout(timeout);
  }, [currentIndex, isTyping, text, speed, deleteSpeed, delay, loop]);

  const prefersReducedMotion =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (prefersReducedMotion) {
    return <span className={className}>{text}</span>;
  }

  return (
    <motion.span
      className={className}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {displayedText}
      {showCursor && (
        <motion.span
          animate={{ opacity: [0, 1, 0] }}
          transition={{ duration: 1, repeat: Infinity, ease: "easeInOut" }}
          className="ml-1 text-brand-gold"
        >
          |
        </motion.span>
      )}
    </motion.span>
  );
};

export default AnimatedTyping;
